import styled from '@emotion/styled'

export const StyledInput = styled.div`
    font-size: 75px;
    color: white;
`